import { t, Trans } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import GppMaybeIcon from '@mui/icons-material/GppMaybe'

export function SubscribePlaceholder() {
  useLingui()
  return (
    <Stack alignItems="center" justifyContent="center" spacing={1} width="100%" height="100%">
      <GppMaybeIcon fontSize="large" />
      <Typography variant="h1" fontSize="30px" fontWeight={700} alignItems="center">
        <Trans>Your subscription does not allow access</Trans>
      </Typography>
      <Trans>You do not have access to this feature with your current subscription. You can upgrade your subscription to access this feature.</Trans>
      <Typography variant="caption" fontSize="16px">
        <a href={'mailto:support.medconnect@promotal.com?subject=My Account does not have a subscritpion'} title={t`Send an email to support`}>
          <Trans>Send an email to support</Trans> (support.medconnect@promotal.com)
        </a>
      </Typography>
    </Stack>
  )
}
